// Disable desktop zoom hook — blocks Ctrl/Cmd +/-/0 and Ctrl/Cmd + wheel/trackpad-pinch (issue #346)
//
// The viewport meta tag and CSS `touch-action` handle mobile pinch / double-tap zoom.
// This hook covers the desktop keyboard and wheel paths that those can't intercept.
//
// Known limitation: browser-menu zoom and OS-level zoom cannot be blocked from web code.

import { useEffect } from 'react';

const ZOOM_KEYS = new Set(['+', '-', '=', '0']);

export function useDisableZoom() {
  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && ZOOM_KEYS.has(e.key)) {
        e.preventDefault();
      }
    };

    // Ctrl/Cmd + wheel (and trackpad pinch, which browsers report as a ctrl+wheel event).
    const handleWheel = (e: WheelEvent) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeydown, { passive: false });
    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      window.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);
}
